 <template>
    <div class="filter-bar">
        <div
            class="current-filters"
            :class="{ 'display-vertical': renderVertically }"
        >
            <div
                v-for="filter in currentFiltersDetails"
                :key="'filter-' + filter.name"
                class="filter-container"
            >
                <label v-if="showLabels" class="filter-main-label">{{
                    filter.label
                }}</label>
                <div class="filter" v-if="ready">
                    <div class="filter-body">
                        <component
                            :is="filter.component"
                            :ref="filter.name"
                            :currentValue="values[filter.name]"
                            :options="filter.options"
                            :name="filter.name"
                            :label="filter.label"
                            :allowReset="allowReset"
                            @changed="setValue(filter.name, $event)"
                            >{{ filter.options }}</component
                        >
                    </div>
                    <span
                        class="far fa-remove pull-right"
                        v-if="filter.removable"
                        @click="removeFilter(filter.name)"
                    ></span>
                </div>
            </div>
            <div class="add-filter-holder">
                <div
                    class="filter add-filter"
                    v-if="availableFilters.length > 0"
                    @click="showAvailableFilters = !showAvailableFilters"
                >
                    <span class="far fa-plus"></span>
                    <span v-if="renderVertically"> {{ t('filter_bar-add_filter') }}</span>
                </div>
                <div class="filter-options" v-if="showAvailableFilters">
                    <span
                        class="far fa-remove pull-right"
                        @click="showAvailableFilters = false"
                    ></span>
                    <label>{{ t('filter_bar-add_filter') }}</label>
                    <div class="clear"></div>
                    <ul>
                        <li
                            v-for="filter in availableFilters"
                            :key="filter.name"
                            @click="addFilter(filter.name)"
                        >
                            {{ filter.label }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="less">
.add-filter-holder {
    display: inline-block;
    position: relative;
    margin: 5px 10px 0px 10px;
    @media screen and (max-width: 502px) {
        width: 95%;
        margin-left: 0;
        margin-top: 10px;
        margin-bottom: 20px;
        display: flex;
        justify-content: flex-end;
    }
}

.current-filters {
    display: flex;
    align-items: flex-end;
    flex-flow: wrap;
    margin: 10px 0px 10px 0px;
    width: 100%;
    padding-bottom: 40px;

    &.display-vertical {
        flex-direction: column;
        flex-flow: column;
        align-items: flex-start;
        padding: 0;
        .filter-container,
        .add-filter-holder {
            margin-left: 0;
            margin-bottom: 20px;
        }
    }
    @media screen and (max-width: 502px) {
        &.display-vertical {
            flex-direction: column;
            padding: 0;
            .filter-container,
            .add-filter-holder {
                margin-top: 20px;
                margin-right: 20px;
            }
        }
    }
}

.filter-container {
    margin-left: 10px;
    margin-top: 5px;
    margin-bottom: 0;
    display: inline-flex;
    flex-direction: column;

    &:first-child {
        margin-left: 0;
    }
    @media screen and (max-width: 502px) {
        width: 95%;
        margin-left: 0;
    }

    .filter-main-label {
        margin-bottom: 0.3rem;
        font-size: 11px;
        color: #888;
    }

    .filter-body {
        flex-grow: 1;
    }
}
.filter {
    .filter-label {
        cursor: pointer;
    }
    border: 1px solid #ddd;
    padding: 7px 10px 7px 10px;
    position: relative;
    border-radius: 5px;
    background: #eee;
    display: inline-flex;
    justify-content: space-between;

    &:has(.kv-search-input) {
        padding: 0 10px 0 0;
    }

    &:first-child {
        margin-left: 0;
    }
    .fa-remove {
        cursor: pointer;
        color: #ff5b5b;
        float: right;
        margin-top: 0px;
        margin-left: 15px;
    }

    &.add-filter {
        min-width: 40px;
        text-align: center;
        justify-content: center;
        background: var(--primary);
        color: #fff;
        cursor: pointer;
        margin-left: 0;
        .fa-plus + span {
            margin-left: 10px;
            display: inline-block;
        }
    }
}
.filter-options {
    position: absolute;
    background: #fff;
    color: #333;
    left: 0px;
    width: 200px;
    padding: 0px;
    top: 100%;
    margin-top: 12px;
    text-align: left;
    border-radius: 4px;
    z-index: 10;
    cursor: default;
    border: 1px solid #ddd;
    &:before,
    &:after {
        content: "";
        display: block;
        position: absolute;
        top: -7px;
        border-right: 7px solid transparent;
        border-left: 7px solid transparent;
        border-bottom: 7px solid #ccc;
        left: 9px;
    }
    &:after {
        top: -6px;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #fff;
        border-left: 6px solid transparent;
        left: 10px;
    }
    .fa-remove {
        margin-top: 5px;
        margin-right: 5px;
        margin-left: 0;
        color: #888;
        cursor: pointer;
    }
    label {
        color: #666;
        font-weight: 600;
        padding-left: 10px;
        margin-top: 15px;
        font-size: 13px;
    }
    ul {
        padding-left: 0;
        margin: 0;
        li {
            margin: 0;
            list-style: none;
            cursor: pointer;
            font-size: 12px;
            padding: 8px 12px;
            display: flex;
            align-items: center;
            input[type="checkbox"] {
                float: left;
                margin-top: 2px;
                margin-right: 5px;
            }
            input[type="checkbox"] + label {
                cursor: pointer;
                vertical-align: middle;
                margin-left: 4px;
                margin-top: 2px;
                margin-bottom: 2px;
            }
            &.disabled {
                cursor: default;
                color: #888;
            }
            &.selected {
                background: #eee;
            }
            &:not(.disabled):hover {
                background: #eee;
            }
        }
    }
    .filter-actions {
        border-top: 1px solid #ddd;
        padding: 8px;
        text-align: right;
        .btn {
            font-size: 12px;
            font-weight: 400;
        }
    }
}
</style>
<script>
import FilterPeriod from "./filters/period";
import FilterBranch from "./filters/branch";
import FilterClient from "./filters/client";
import FilterMinMax from "./filters/min-max";
import FilterMinMaxWithPeriod from "./filters/min-max-with-relative-period";
import FilterMinMaxDates from "./filters/min-max-dates";
import FilterSelect from "./filters/select";
import FilterCheckbox from "./filters/checkbox";
import FilterNumber from "./filters/number";
import FilterForm from "./filters/form";
import { filter } from "minimatch";

export default {
    name: "filter-bar",
    components: {
        period: FilterPeriod,
        branch: FilterBranch,
        client: FilterClient,
        "min-max": FilterMinMax,
        selectbox: FilterSelect,
        checkbox: FilterCheckbox,
        "min-max-with-period": FilterMinMaxWithPeriod,
        "min-max-dates": FilterMinMaxDates,
        number: FilterNumber,
        forms: FilterForm,
    },
    props: {
        showLabels: {
            type: Boolean,
            default: false,
        },
        isVertical: {
            type: Boolean,
            default: null,
        },
        hasBranchFilter: {
            type: Boolean,
            default: true,
        },
        hasClientFilter: {
            type: Boolean,
            default: false,
        },
        hasPeriodFilter: {
            type: Boolean,
            default: true,
        },
        hasFormFilter: {
            type: Boolean,
            default: false,
        },
        updateQueryString: {
            type: Boolean,
            default: true,
        },
        allowReset: {
            type: Boolean,
            default: false,
        },
        queryStringParam: {
            type: String,
            default: "filter"
        },
        filters: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            showAvailableFilters: false,
            renderVerticallyMode: false,
            values: {},
            lastValuesEmitted: {},
            filterEventWithUserInteration: ["client"],
            selectedFilters: [],
            defaultFilters: [],
            ready: false,
        };
    },
    computed: {
        filterOptions() {
            // Merge default filters with provided filters, with provided filters taking precedence
            const mergedFilters = [...this.defaultFilters];

            if (this.filters && this.filters.length) {
                this.filters.forEach(filter => {
                    const existingIndex = mergedFilters.findIndex(f => f.name === filter.name);
                    if (existingIndex !== -1) {
                        mergedFilters[existingIndex] = filter;
                    } else {
                        mergedFilters.push(filter);
                    }
                });
            }

            return mergedFilters;
        },
        availableFilters() {
            return this.filterOptions.filter(
                filter => !this.selectedFilters.includes(filter.name)
            );
        },
        currentFiltersDetails() {
            return this.selectedFilters
                .map((filterName) => {
                    return this.filterOptions.find(item => item.name === filterName);
                })
                .filter((filter) => filter !== undefined);
        },
        renderVertically() {
            return this.isVertical !== null
                ? this.isVertical
                : this.renderVerticallyMode;
        },
    },
    mounted() {
      this.initializeDefaultFilters();
      if (this.updateQueryString) {
            this.loadQueryStringFilter();
        }
        window.addEventListener("resize", () => {
            this.renderVerticallyMode = window.innerWidth <= 500;
        });
        this.ready = true;
    },
    beforeUnmount() {
        window.removeEventListener("resize", () => {});
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
      filter,
        loadQueryStringFilter() {
            if (this.$route.query[this.queryStringParam]) {
                try {
                    const queryValues = JSON.parse(this.$route.query[this.queryStringParam]);
                    if (queryValues && typeof queryValues === "object" && !Array.isArray(queryValues)) {
                        this.values = queryValues;
                        this.$nextTick(() => {
                          for (let filter in this.values) {
                            if (!this.selectedFilters.includes(filter)) {
                              this.addFilter(filter, false);
                            }
                          }
                        });
                    }
                } catch (e) {
                    console.error("Error parsing filter from query string", e);
                }
            }
        },
        initializeDefaultFilters() {
            if (this.hasPeriodFilter) {
                this.registerDefaultFilter({
                    component: "period",
                    label: this.t('filter_bar-period'),
                    removable: false,
                    name: "period",
                });
            }

            if (this.$root.$store?.state?.place?.branches?.length > 1 && this.hasBranchFilter) {
                this.registerDefaultFilter({
                    component: "branch",
                    label: this.t('filter_bar-branches'),
                    removable: true,
                    name: "branch",
                });
            }

            if (this.hasClientFilter) {
                this.registerDefaultFilter({
                    component: "client",
                    label: this.t('filter_bar-client'),
                    removable: true,
                    name: "client",
                });
            }

            if (this.hasFormFilter) {
                this.registerDefaultFilter({
                    component: "forms",
                    label: this.t('filter_bar-form'),
                    removable: true,
                    name: "forms",
                });
            }
        },
        registerDefaultFilter(filter) {
            if (filter.name === undefined) {
                filter.name = filter.component;
            }

            const existingFilterIndex = this.defaultFilters.findIndex(f => f.name === filter.name);

            if (existingFilterIndex !== -1) {
                this.defaultFilters.splice(existingFilterIndex, 1, filter);
            } else {
                this.defaultFilters.push(filter);
            }
        },
        registerFilter(filter) {
            // This method is kept for backward compatibility
            this.registerDefaultFilter(filter);
        },
        addFilter(filter, showOptions = true) {
            if (!this.selectedFilters.includes(filter)) {
                this.selectedFilters.push(filter);

                this.$nextTick(() => {
                    if (this.$refs[filter]) {
                        this.$refs[filter][0].showOptions = showOptions;
                    }
                });
            }

            this.showAvailableFilters = false;
        },
        removeFilter(filter) {
            const index = this.selectedFilters.indexOf(filter);
            if (index > -1) {
                this.selectedFilters.splice(index, 1);
                const tempValues = { ...this.values };
                if (tempValues[filter] !== undefined) {
                    delete tempValues[filter];
                }
                this.values = tempValues;
                this.changed();
            }
        },
        setValue(filter, event) {
          this.$set(this.values, filter, event);
          this.changed();
        },
        setValues(values) {
            for (let filter in values) {
                let value = values[filter];
                if (!this.selectedFilters.includes(filter) && value !== null) {
                    this.addFilter(filter, false);
                }
            }
            this.values = values;
        },
        changed() {
            let currentValues = JSON.stringify(this.values);
            if (currentValues !== this.lastValuesEmitted) {
                this.$emit("changed", { ...this.values });
                this.lastValuesEmitted = currentValues;
            }
        },
    },
    watch: {
        values: {
            handler() {
              if (this.updateQueryString) {
                const oldQuery = JSON.parse(JSON.stringify(this.$route.query));
                const newQuery = JSON.parse(JSON.stringify(this.$route.query));
                newQuery[this.queryStringParam] = JSON.stringify(this.values);
                if (JSON.stringify(newQuery) !== JSON.stringify(oldQuery)) {
                  this.$router.replace({ query: newQuery }).catch(() => {});
                }
              }
            },
            deep: true,
        },
    },
};
</script>
